/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_FindingsInputs */

const en_directory_agent_readiness_findings = /** @type {(inputs: Directory_Agent_Readiness_FindingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Findings`)
};

const zh_directory_agent_readiness_findings = /** @type {(inputs: Directory_Agent_Readiness_FindingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关键发现`)
};

/**
* | output |
* | --- |
* | "Findings" |
*
* @param {Directory_Agent_Readiness_FindingsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_findings = /** @type {((inputs?: Directory_Agent_Readiness_FindingsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_FindingsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_findings(inputs)
	return zh_directory_agent_readiness_findings(inputs)
});
export { directory_agent_readiness_findings as "directory.agent_readiness.findings" }